/**
 * Created by Raul on 20/07/2018.
 */

import {Injectable} from '@angular/core';
import {IResourceMethod, ResourceAction, ResourceHandler, ResourceParams, ResourceRequestMethod} from '@ngx-resource/core';
import {AuthServerProvider} from '../../../auth/auth-jwt.service';
import {ResourceAuth} from '../../../auth/authenticate.resource';
import {ConfiguracionChatModel} from './configuracion-chat.model';

@Injectable()
@ResourceParams({
  pathPrefix: '/configuracion'
})
export class ChatConfiguracionResource extends ResourceAuth {
  constructor(handler: ResourceHandler, auth: AuthServerProvider) {
    super(handler, auth);
  }

  @ResourceAction({
    path: '/na/configuracion-chat',
    method: ResourceRequestMethod.Get
  })
  obtenerConfiguracionChat: IResourceMethod<any, ConfiguracionChatModel>;
}
